import * as React from 'react';
import Media from 'react-media';

import Imgix from 'js/components/Imgix';

import { Grid, Typography, Typography2, useTheme } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import MobileAppBadges from 'bundles/page/components/MobileAppBadges';
import type { MobileLexUpsellProps, UserAgentProps } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/academics/MobileLexUpsell';

const MobileLexUpsell = ({ title, description, visual, userAgent }: MobileLexUpsellProps & UserAgentProps) => {
  const theme = useTheme();

  return (
    <div className="rc-MobileLexUpsell rc-Section styled">
      <Grid container spacing={24}>
        <Grid item md={8} sm={12}>
          <Typography variant="h2">{title}</Typography>
          <Markdown className="description" source={description} />
          <Typography2 component="h3" className="download-app-header" variant="subtitleMedium">
            {_t("Download Coursera's mobile app")}
          </Typography2>
          <MobileAppBadges mdJustifyStart />
        </Grid>
        <Media
          query={{ minWidth: theme.breakpoints.values.md }}
          render={() => (
            <Grid item lg={4} md={4} sm={12}>
              <Imgix className="info-card-banner" src={visual?.url ?? ''} alt="" />
            </Grid>
          )}
          defaultMatches={userAgent?.isMobileBrowser}
        />
      </Grid>
    </div>
  );
};

export default MobileLexUpsell;
